import { Price } from '../catalogue-category/price.model';
import { IProduct, IProductDeletable, IProductFavoratable, IProductNavigatable } from '../contract/product.contract';
import { Router } from '@angular/router';

export class AnalyticalTest implements IProduct, IProductNavigatable, IProductDeletable, IProductFavoratable {

    public temperatureRequirement: string;
    public timeRequirement: string;
    public team: string;
    public measurands: string;
    public substanceAttributes: AnalyticalTestAttribute[] = [];
    public expanded = false;
    public infoLoaded = false;
    public attributesLoaded = false;
    public loading: false;
    public resourceType: string;
    public recommendationLevel: number;
    public popularity: number;
    public isFavourite?: boolean;
    public shouldDisplayPrice: boolean;
    // @ts-ignore
    public discriminator;
    // @ts-ignore
    public iProductDeletableDiscriminator;
    // @ts-ignore
    public iProductFavoratableDiscriminator;

    public detailPage = ['lab-tests/analytical-test/', this.id];

    constructor(public id: number,
        public name: string,
        public description: string,
        public price: Price,
        public turnAroundDuration: string,
        public code: string) {
        this.iProductDeletableDiscriminator = 'IProductDeletable';
        this.iProductFavoratableDiscriminator = 'IProductFavoratable';
    }

    assignExtendedInfo(
        temperatureRequirement: string,
        timeRequirement: string,
        measurands: string
    ) {
        this.temperatureRequirement = temperatureRequirement;
        this.timeRequirement = timeRequirement;
        this.measurands = measurands;
    }
}

export class CatalogueItemList {
    constructor(public items: AnalyticalTest[]) {
    }
}

export class AnalyticalTestAttribute {
    public id: number;
    public values: AnalyticalTestAttributeValue[];
    public analyticalTestId: number;
    public influenceTest: boolean;

    constructor(public name: string, public rank: number) {
    }
}

export class AnalyticalTestAttributeValue {
    public id: number;
    public analyticalTestAttributeId: number;

    constructor(public name: string, public rank: number) {
    }
}

export const   assignExtendedInfo = (test: AnalyticalTest,
    temperatureRequirement: string,
    timeRequirement: string,
    measurands: string
) => {
    test.temperatureRequirement = temperatureRequirement;
    test.timeRequirement = timeRequirement;
    test.measurands = measurands;
};
